export enum CustomEventName {
  Example = "user-action",
  ShareFailed = "share-failed",
  ExpandVoicePopover = "expand-voice-popover",
}

export interface CustomEventMap {
  [CustomEventName.Example]: {
    elementId: string;
    timestamp: number;
  };
  [CustomEventName.ShareFailed]: {
    email: string;
  };
  [CustomEventName.ExpandVoicePopover]: {
    noteId: string;
  };
}
